<template>
  <div
    :class="
      isLowerFixed
        ? 'lower-header container hidden-on-mobile edged-centered-space-evenly-flexbox make-space-evenly fixed'
        : 'lower-header container hidden-on-mobile edged-centered-space-evenly-flexbox make-space-evenly'
    "
  >
    <a href="/" class="logo">
      <IconBase icon-name="I.AM.GIA" width="251px" height="45px" view-box="0 0 251 45">
        <Logo />
      </IconBase>
    </a>

    <MainMenu />

    <div class="top-menu">
      <ul>
        <li>
          <a href="/pages/wishlist">
            Wishlist
            <span class="slash">/</span>
            <span class="wishListCounterID">{{ wishlistCount }}</span>
          </a>
        </li>
        <li>
          <a href="#" @click="showCart">
            My Bag
            <span class="slash">/</span>
            <span class="CartCount">{{ cartCount }}</span>
          </a>
        </li>
      </ul>
    </div>

    <button type="button" @click="showSearchModal">
      <IconBase icon-name="cart" width="16px" height="16px" view-box="0 0 21 21">
        <SearchIcon />
      </IconBase>
    </button>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import BrandLogo from '../atoms/BrandLogo.vue'
import Logo from '../atoms/Logo.vue'
import MainMenu from '../atoms/MainMenu.vue'
import IconBase from '../atoms/IconBase.vue'
import SearchIcon from '../atoms/SearchIcon.vue'

export default {
  data: () => ({
    isShowSearch: false,
  }),
  computed: mapGetters(['wishlistCount', 'cartCount']),
  components: {
    BrandLogo,
    MainMenu,
    Logo,
    IconBase,
    SearchIcon,
  },
  props: {
    isLowerFixed: { type: Boolean, default: false },
  },
  methods: {
    showSearchModal(e) {
      e.preventDefault()
      this.$store.commit('showSearch')
      //this.$emit('show-quick-search')
    },
    showCart(e) {
      e.preventDefault()
      this.$store.commit('showCart')
      return this.$store.state.cart.cartFlag
    },
  },
}
</script>
